<template>
  <div v-if="store" class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="flex justify-end">
      <StoreConfigurationStatusBadge :configuration-status="store.billingConfigStatus" />
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField label="Niveau de facturation" :value="$t(`organization.invoice_level.${invoiceLevel}`)" />
      <StackedField label="RIB" :value="store.ibanPresent ? 'Renseigné' : 'Non renseigné'" />
      <StackedField label="Modèle de rémunération">
        <Selector
          v-if="editMode && remunerationModelEditable"
          id="remuneration_model"
          name="remuneration_model"
          v-model="remunerationModel"
          :options="remunerationModelOptions"
        />
        <template v-else>{{ t_remuneration_model(remunerationModel) || "—" }}</template>
      </StackedField>
      <StackedField label="Délai de facturation" :value="billingDelay" />
      <StackedField label="Mois en avance" :value="advanceMonthsCommission" />
      <StackedField label="Taux de churn accepté" :value="churnRate" />
    </div>
    <div class="flex flex-row-reverse gap-x-4">
      <SecondaryButton v-if="!editMode && remunerationModelEditable" @click="editMode = true">
        Modifier le modèle de rémunération
      </SecondaryButton>
      <template v-if="editMode">
        <SecondaryButton @click="editMode = false">Annuler</SecondaryButton>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { StackedField, SecondaryButton, Selector } from "@estaly/ui";
import StoreConfigurationStatusBadge from "@/components/StoreConfigurationStatusBadge.vue";

export default {
  components: {
    StoreConfigurationStatusBadge,
    SecondaryButton,
    StackedField,
    Selector,
  },

  props: ["store", "isStoreSetup"],

  data() {
    return {
      editMode: false,
      remunerationModelValue: this.store?.remunerationModel,
    };
  },

  computed: {
    ...mapGetters("stores", ["effectiveInvoiceLevel", "getRemunerationModels"]),
    remunerationModelOptions() {
      return this.getRemunerationModels().map((v) => ({
        value: v,
        label: this.t_remuneration_model(v),
      }));
    },
    invoiceLevel() {
      return this.effectiveInvoiceLevel(this.store);
    },
    remunerationModel: {
      get() {
        return this.store.remunerationModel;
      },
      set(value) {
        this.remunerationModelValue = value;
      },
    },
    advanceMonthsCommission() {
      return this.store.advanceMonthsCommission;
    },
    billingDelay() {
      return this.store.billingDelay;
    },
    churnRate() {
      return this.store.churnRate != null ? `${(this.store.churnRate * 100).toFixed(2)} %` : null;
    },
    remunerationModelEditable() {
      return this.isStoreSetup;
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["update"]),

    t_remuneration_model(value) {
      return this.$t(`store.remuneration_model.${value}`);
    },

    async submitEdit() {
      const response = await this.update({
        storeId: this.store.id,
        data: { remunerationModel: this.remunerationModelValue },
      });
      if (!response?.success) return;

      await this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
      this.$emit("remunerationModelUpdated");
      this.editMode = false;
    },
  },

  watch: {
    async remunerationModelValue(newValue) {
      if (newValue && this.editMode) await this.submitEdit();
    },
  },
};
</script>
